import { render, staticRenderFns } from "./SpinnerComponent.vue?vue&type=template&id=c4eddffc"
import script from "./SpinnerComponent.vue?vue&type=script&lang=ts"
export * from "./SpinnerComponent.vue?vue&type=script&lang=ts"
import style0 from "./SpinnerComponent.vue?vue&type=style&index=0&id=c4eddffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports